import { render, staticRenderFns } from "./integration-users.vue?vue&type=template&id=b945f00c&"
import script from "./integration-users.vue?vue&type=script&lang=js&"
export * from "./integration-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports